import React from "react";

const Services = () => {
    return (
        <div id="fh5co-features" className="animate-box">
            <div className="container">
                <div className="services-padding">
                    <div className="row">
                        <div className="col-md-8 col-md-offset-2 text-center fh5co-heading">
                            <h2>Technical Expertise</h2>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="feature-left">
                                <span className="icon">
                                    <i className="icon-network"></i>
                                </span>
                                <div className="feature-copy">
                                    <h3>Distributed Systems</h3>
                                    <p>Building scalable and resilient distributed systems that can handle high loads with low latency.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="feature-left">
                                <span className="icon">
                                    <i className="icon-cog2"></i>
                                </span>
                                <div className="feature-copy">
                                    <h3>Machine Learning</h3>
                                    <p>Developing and deploying machine learning models that solve real-world problems efficiently.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="feature-left">
                                <span className="icon">
                                    <i className="icon-bargraph"></i>
                                </span>
                                <div className="feature-copy">
                                    <h3>Big Data Analytics</h3>
                                    <p>Analyzing large datasets to extract valuable insights and drive data-informed decisions.</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-4 text-center">
                            <div className="feature-left">
                                <span className="icon">
                                    <i className="icon-code"></i>
                                </span>
                                <div className="feature-copy">
                                    <h3>API Development</h3>
                                    <p>Designing and implementing robust APIs that enable seamless integration between systems.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="feature-left">
                                <span className="icon">
                                    <i className="icon-cloud"></i>
                                </span>
                                <div className="feature-copy">
                                    <h3>Cloud Solutions</h3>
                                    <p>Architecting cloud-native solutions that leverage the best of modern cloud platforms.</p>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-4 text-center">
                            <div className="feature-left">
                                <span className="icon">
                                    <i className="icon-monitor"></i>
                                </span>
                                <div className="feature-copy">
                                    <h3>Web Design</h3>
                                    <p>Creating modern, responsive, and user-friendly websites that stand out in the digital landscape.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Services; 